// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2ZrfU","label":"Section_label__1fsWH","contentWrap":"Section_contentWrap__3dhoX","footer":"Section_footer__3iORe","footerInner":"Section_footerInner__LWmlv"};